<template minapp='mpx' xlang='wxml'>
  <view class='es-loading' wx:style="{{style}}">
    <view class='es-loading__spinner' wx:for="{{12}}" wx:key="item"></view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      size: Number
    },
    computed: {
      style() {
        if (!this.size) {
          return
        }
        const value = `${this.size}px`
        return {
          width: value,
          height: value
        }
      }
    }
  })
</script>

<style>
  .es-loading {
    position: relative;
    display: inline-block;
    width: 1em;
    height: 1em;
    font-size: 24px;
  }

  .es-loading__spinner {
    position: absolute;
    left: 44.5%;
    top: 37%;
    width: 2px;
    height: 25%;
    border-radius: 50%/20%;
    opacity: 0.25;
    background-color: currentColor;
    -webkit-animation: spinner-fade 1s linear infinite;
    animation: spinner-fade 1s linear infinite;
  }

  .es-loading__spinner:first-child {
    -webkit-animation-delay: 0s;
    animation-delay: 0s;
    -webkit-transform: rotate(-150deg) translateY(-150%);
    transform: rotate(-150deg) translateY(-150%);
  }

  .es-loading__spinner:nth-child(2) {
    -webkit-animation-delay: 0.083333333333333s;
    animation-delay: 0.083333333333333s;
    -webkit-transform: rotate(-120deg) translateY(-150%);
    transform: rotate(-120deg) translateY(-150%);
  }

  .es-loading__spinner:nth-child(3) {
    -webkit-animation-delay: 0.166666666666667s;
    animation-delay: 0.166666666666667s;
    -webkit-transform: rotate(-90deg) translateY(-150%);
    transform: rotate(-90deg) translateY(-150%);
  }

  .es-loading__spinner:nth-child(4) {
    -webkit-animation-delay: 0.25s;
    animation-delay: 0.25s;
    -webkit-transform: rotate(-60deg) translateY(-150%);
    transform: rotate(-60deg) translateY(-150%);
  }

  .es-loading__spinner:nth-child(5) {
    -webkit-animation-delay: 0.333333333333333s;
    animation-delay: 0.333333333333333s;
    -webkit-transform: rotate(-30deg) translateY(-150%);
    transform: rotate(-30deg) translateY(-150%);
  }

  .es-loading__spinner:nth-child(6) {
    -webkit-animation-delay: 0.416666666666667s;
    animation-delay: 0.416666666666667s;
    -webkit-transform: rotate(0deg) translateY(-150%);
    transform: rotate(0deg) translateY(-150%);
  }

  .es-loading__spinner:nth-child(7) {
    -webkit-animation-delay: 0.5s;
    animation-delay: 0.5s;
    -webkit-transform: rotate(30deg) translateY(-150%);
    transform: rotate(30deg) translateY(-150%);
  }

  .es-loading__spinner:nth-child(8) {
    -webkit-animation-delay: 0.583333333333333s;
    animation-delay: 0.583333333333333s;
    -webkit-transform: rotate(60deg) translateY(-150%);
    transform: rotate(60deg) translateY(-150%);
  }

  .es-loading__spinner:nth-child(9) {
    -webkit-animation-delay: 0.666666666666667s;
    animation-delay: 0.666666666666667s;
    -webkit-transform: rotate(90deg) translateY(-150%);
    transform: rotate(90deg) translateY(-150%);
  }

  .es-loading__spinner:nth-child(10) {
    -webkit-animation-delay: 0.75s;
    animation-delay: 0.75s;
    -webkit-transform: rotate(120deg) translateY(-150%);
    transform: rotate(120deg) translateY(-150%);
  }

  .es-loading__spinner:nth-child(11) {
    -webkit-animation-delay: 0.833333333333333s;
    animation-delay: 0.833333333333333s;
    -webkit-transform: rotate(150deg) translateY(-150%);
    transform: rotate(150deg) translateY(-150%);
  }

  .es-loading__spinner:nth-child(12) {
    -webkit-animation-delay: 0.916666666666667s;
    animation-delay: 0.916666666666667s;
    -webkit-transform: rotate(180deg) translateY(-150%);
    transform: rotate(180deg) translateY(-150%);
  }

  @-webkit-keyframes spinner-fade {
    0% {
      opacity: 0.85;
    }

    50% {
      opacity: 0.25;
    }

    to {
      opacity: 0.25;
    }
  }

  @keyframes spinner-fade {
    0% {
      opacity: 0.85;
    }

    50% {
      opacity: 0.25;
    }

    to {
      opacity: 0.25;
    }
  }
</style>

<script name='json'>
  module.exports = {
    component: true
  }
</script>

